import Button from "@/lib/Button";
import { LineItem, LocalLineItems } from "./types";
import { Dispatch, SetStateAction } from "react";

export default function QuickSelectLineItems({
  setSelectedLineItemKeys,
  lineItems,
}: {
  setSelectedLineItemKeys: Dispatch<SetStateAction<string[]>>;
  lineItems: LocalLineItems[];
}) {
  return (
    <div className="p-4 flex flex-col gap-2">
      <div className="text-sm font-bold">Select to Expedite or Modify</div>
      <div className="flex gap-4">
        <Button
          onClick={() => setSelectedLineItemKeys(getAllLineItemsKey(lineItems))}
        >
          Select All
        </Button>
        <Button
          onClick={() =>
            setSelectedLineItemKeys(getAllLowestQuantityLineItemsKey(lineItems))
          }
        >
          Select Lowest Quantities
        </Button>
      </div>
    </div>
  );
}

function getAllLineItemsKey(parts: LocalLineItems[]): string[] {
  return parts.reduce(
    (keys, { item_lines }) => [...keys, ...item_lines.map(({ key }) => key)],
    [] as string[],
  );
}

function getAllLowestQuantityLineItemsKey(parts: LocalLineItems[]): string[] {
  return parts.reduce(
    (keys, { item_lines }) => [
      ...keys,
      ...getLowestQuantityLineItemsKey(item_lines),
    ],
    [] as string[],
  );
}

function getLowestQuantityLineItemsKey(lineItems: LineItem[]): string[] {
  const lowestQuantity = lineItems[0].quantity;
  return lineItems
    .filter(({ quantity }) => quantity === lowestQuantity)
    .map(({ key }) => key);
}
